module.exports = __webpack_public_path__ + "static/avg_sale_price-f321be92056822f535c4b23612c8f7f6.png";